var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonXing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206.93 190.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #041130;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u592E\\u94CB_1",
    "data-name": "\\u592E\\u94CB 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.29,94.21c-.05,0-.1,0-.15,0-1.8-.09-3.2-1.62-3.11-3.42L100.2,3.12c.09-1.8,1.76-3.27,3.42-3.11,1.8,.09,3.2,1.62,3.11,3.42l-4.18,87.67c-.09,1.75-1.53,3.11-3.27,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.29,94.21c-1.12,0-2.22-.58-2.82-1.63L50.54,13.26c-.91-1.56-.37-3.56,1.19-4.47,1.52-.89,3.55-.38,4.46,1.19l45.92,79.32c.91,1.56,.37,3.56-1.19,4.47-.51,.3-1.07,.44-1.63,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.29,94.21c-.54,0-1.1-.14-1.61-.42L1.66,39.52c-1.57-.89-2.13-2.88-1.23-4.45,.88-1.57,2.88-2.11,4.45-1.24l96.02,54.27c1.57,.89,2.13,2.88,1.23,4.45-.6,1.06-1.7,1.66-2.84,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.29,94.21H19.97c-1.8,0-3.27-1.46-3.27-3.27s1.46-3.27,3.27-3.27H99.29c1.8,0,3.27,1.46,3.27,3.27s-1.46,3.27-3.27,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.27,148.49c-1.14,0-2.25-.6-2.84-1.66-.89-1.57-.34-3.57,1.23-4.45l96.02-54.27c1.57-.89,3.57-.34,4.45,1.24,.89,1.57,.34,3.57-1.23,4.45L4.88,148.06c-.51,.29-1.06,.42-1.61,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.63,162.91c-.56,0-1.12-.14-1.63-.44-1.57-.9-2.1-2.9-1.2-4.46l39.66-68.69c.91-1.57,2.93-2.09,4.47-1.2,1.57,.9,2.1,2.9,1.2,4.46l-39.66,68.69c-.61,1.05-1.71,1.63-2.83,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.47,190.24c-1.74,0-3.19-1.37-3.27-3.13l-4.18-96.02c-.08-1.8,1.32-3.33,3.12-3.4,2.13-.13,3.34,1.33,3.41,3.12l4.18,96.02c.08,1.8-1.32,3.33-3.12,3.4-.05,0-.1,0-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.95,162.91c-1.12,0-2.22-.59-2.83-1.63l-39.67-68.69c-.9-1.56-.37-3.56,1.2-4.46,1.52-.89,3.54-.38,4.47,1.2l39.67,68.69c.9,1.56,.37,3.56-1.2,4.46-.51,.3-1.07,.44-1.63,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.56,123.44c-.53,0-1.05-.12-1.55-.39l-54.28-29.22c-1.59-.86-2.19-2.84-1.33-4.42,.85-1.6,2.85-2.19,4.42-1.33l54.28,29.22c1.59,.86,2.19,2.84,1.33,4.42-.59,1.1-1.72,1.72-2.88,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.66,98.39s-.09,0-.13,0l-104.37-4.17c-1.8-.07-3.21-1.59-3.14-3.39,.08-1.8,1.34-3.42,3.39-3.13l104.37,4.17c1.8,.07,3.21,1.59,3.14,3.39-.08,1.76-1.52,3.14-3.27,3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.29,94.21c-1.09,0-2.16-.55-2.78-1.55-.94-1.53-.47-3.55,1.06-4.5l87.67-54.27c1.53-.94,3.54-.48,4.5,1.06,.94,1.53,.47,3.55-1.06,4.5l-87.67,54.27c-.54,.33-1.13,.49-1.72,.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.29,94.21c-.58,0-1.16-.15-1.68-.46-1.54-.93-2.04-2.94-1.11-4.48l37.57-62.62c.94-1.56,2.95-2.04,4.48-1.12,1.54,.93,2.04,2.94,1.11,4.48l-37.57,62.62c-.61,1.02-1.69,1.59-2.8,1.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonXing);
export default __webpack_public_path__ + "static/media/button_xing.1b9c8afaefd28ccdfbc66e1aac0117fd.svg";
export { ForwardRef as ReactComponent };